import { Fragment } from 'react'

import cn from 'clsx'
import { NavLink } from 'react-router'

import BlogCategoryLink from '@/components/BlogCategoryLink'
import { BLOG_CATEGORIES } from '@/utils/blogCategories'

export default function BlogCategoryNav() {
  return (
    <nav className='flex flex-wrap gap-x-1 gap-y-1 sm:gap-0'>
      <NavLink
        className={({ isActive }) =>
          cn('px-0 sm:px-sm', {
            'bg-gray-700 text-white hover:text-white dark:bg-gray-200 dark:text-black dark:hover:text-black': isActive,
            'text-contrast hover:bg-gray-100 hover:text-contrast dark:hover:bg-gray-800': !isActive
          })
        }
        end={true}
        to='/blog'
      >
        All
      </NavLink>
      {BLOG_CATEGORIES.map((category) => (
        <Fragment key={category}>
          <span className='hidden px-sm text-decoration md:inline' role='presentation'>
            |
          </span>
          <BlogCategoryLink activeClassName={true} category={category} className='px-0 sm:px-sm' />
        </Fragment>
      ))}
    </nav>
  )
}
